import React from 'react';
import PropTypes from 'prop-types';
import { Search, X } from 'lucide-react';

export function ReportDraftFindReplacePanel({
  labels,
  query,
  replaceValue,
  caseSensitive,
  matchCount,
  currentMatch,
  lastReplaceCount,
  onQueryChange,
  onReplaceChange,
  onToggleCase,
  onPrev,
  onNext,
  onReplace,
  onReplaceAll,
  onClose,
}) {
  return (
    <div className="report-draft-editor__find-replace" role="region" aria-label={labels.title}>
      <div className="report-draft-editor__find-replace-head">
        <div className="report-draft-editor__find-replace-title-wrap">
          <Search size={14} />
          <span className="report-draft-editor__find-replace-title">{labels.title}</span>
        </div>
        <button
          type="button"
          className="report-draft-editor__toolbar-button"
          aria-label={labels.close}
          title={labels.close}
          onClick={onClose}
        >
          <X size={16} />
        </button>
      </div>

      <div className="report-draft-editor__find-replace-row">
        <input
          type="text"
          value={query}
          onChange={(event) => onQueryChange(event.target.value)}
          placeholder={labels.searchPlaceholder}
          className="report-draft-editor__find-replace-input"
        />
        <div className="report-draft-editor__find-replace-actions">
          <button type="button" className="report-draft-editor__toolbar-chip" onClick={onPrev} disabled={!matchCount}>
            {labels.previous}
          </button>
          <button type="button" className="report-draft-editor__toolbar-chip" onClick={onNext} disabled={!matchCount}>
            {labels.next}
          </button>
        </div>
      </div>

      <div className="report-draft-editor__find-replace-row">
        <input
          type="text"
          value={replaceValue}
          onChange={(event) => onReplaceChange(event.target.value)}
          placeholder={labels.replacePlaceholder}
          className="report-draft-editor__find-replace-input"
        />
        <div className="report-draft-editor__find-replace-actions">
          <button type="button" className="report-draft-editor__toolbar-chip" onClick={onReplace} disabled={!matchCount}>
            {labels.replace}
          </button>
          <button type="button" className="report-draft-editor__toolbar-chip" onClick={onReplaceAll} disabled={!matchCount}>
            {labels.replaceAll}
          </button>
        </div>
      </div>

      <div className="report-draft-editor__find-replace-footer">
        <label className="report-draft-editor__find-replace-case-toggle">
          <input type="checkbox" checked={caseSensitive} onChange={onToggleCase} />
          <span>{labels.caseSensitive}</span>
        </label>
        <span className="report-draft-editor__find-replace-count" aria-live="polite">
          {matchCount > 0 ? `${currentMatch}/${matchCount}` : labels.noMatches}
        </span>
      </div>

      {lastReplaceCount > 0 ? (
        <div className="report-draft-editor__find-replace-result" aria-live="polite">
          {labels.replacedCount.replace('{{count}}', String(lastReplaceCount))}
        </div>
      ) : null}
    </div>
  );
}

ReportDraftFindReplacePanel.propTypes = {
  labels: PropTypes.shape({
    title: PropTypes.string.isRequired,
    close: PropTypes.string.isRequired,
    searchPlaceholder: PropTypes.string.isRequired,
    replacePlaceholder: PropTypes.string.isRequired,
    previous: PropTypes.string.isRequired,
    next: PropTypes.string.isRequired,
    replace: PropTypes.string.isRequired,
    replaceAll: PropTypes.string.isRequired,
    caseSensitive: PropTypes.string.isRequired,
    noMatches: PropTypes.string.isRequired,
    replacedCount: PropTypes.string.isRequired,
  }).isRequired,
  query: PropTypes.string.isRequired,
  replaceValue: PropTypes.string.isRequired,
  caseSensitive: PropTypes.bool.isRequired,
  matchCount: PropTypes.number.isRequired,
  currentMatch: PropTypes.number.isRequired,
  lastReplaceCount: PropTypes.number.isRequired,
  onQueryChange: PropTypes.func.isRequired,
  onReplaceChange: PropTypes.func.isRequired,
  onToggleCase: PropTypes.func.isRequired,
  onPrev: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onReplace: PropTypes.func.isRequired,
  onReplaceAll: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
